import 'whatwg-fetch'
import { h, render } from 'preact'
import AddToCompareIcon from './components/AddToCompareIcon'
import Compare from './components/Compare'
import AddToWishListButton from './components/AddToCompareButton'
import { initCount } from './helpers/compare'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const addToCompareContainer = document.querySelector(
  '.js-add-to-compare-button'
)
const compareContainer = document.querySelector('.js-compare')
const countContainers = document.querySelectorAll('.js-compare-count')
const iconContainer = document.querySelectorAll('.js-add-to-compare-icon')

if (compareContainer) {
  const { ifempty } = compareContainer.dataset
  render(<Compare ifEmpty={ifempty} />, compareContainer)
}

;[...iconContainer].forEach(icon => {
  const { id } = icon.dataset
  render(<AddToCompareIcon id={id} />, icon)
})

if (countContainers.length) {
  initCount()
}



// WEBPACK FOOTER //
// ./src/js/compare/index.js